import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const attachVolumeToStacklet = (
  id: number,
  volume_uuid: string,
): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { action: 'volume_attach', volume_uuid },
  });
